export const rulebookTranslations = {
  en: {
    pageTitle: 'Navigation Regulations',
    generalRules: 'General Rules',
    pleasureBoats: 'Pleasure boats',
    legalNotes: 'Legal notes',
    legalNotes1: 'App “Portolano del Po” – navigation guide for boating enthusiasts to discover the longest river in Italy, its landscapes, its flavors and its local culture, crossing the Biosphere Reserves from Ticino to Po Grande up to the Po Delta.',
    legalNotes2: 'The Po River Basin District Authority and the Interregional Agency for the Po River (hereinafter also Adbpo and AIPo, as well as the implementing Entities) have created this site to promote the Portolano del Po project.',
  },
  it: {
    pageTitle: 'Normative sulla Navigazione',
    generalRules: 'Norme Generali',
    pleasureBoats: 'Imbarcazioni Diportistiche',
    legalNotes: 'Note legali',
    legalNotes1: 'App “Portolano del Po” - guida di navigazione per appassionati diportisti alla scoperta del fiume più lungo d\'Italia, dei suoi paesaggi, dei suoi sapori e della sua cultura locale, attraversando le Riserve della Biosfera dal Ticino al Po Grande fino al Delta Po.',
    legalNotes2: 'L\' Autorità di Bacino Distrettuale del fiume Po e l\'Agenzia Interregionale per il fiume Po (di seguito anche Adbpo e AIPo, nonché Enti realizzatori) hanno realizzato questo sito per promuovere il progetto Portolano del Po.',
  }
}; 